let prioritySeasons = {
 "categories":{
   "Chaussures":{
     "coef":0.5,
   },
   "Chemises et blouses":{
     "coef":0.4,
   },
   "Combinaisons":{
     "coef":0.5,
   },
    "Jeans":{
      "coef":0.35,
   },
    "Jupes":{
     "coef":0.7,
   },
    "Pantalons et pantacourts":{
     "coef":0.35,
   },
    "Pulls et gilets":{
     "coef":0.2,
   },
    "Robes":{
     "coef":0.35,
   },
    "Sacs":{
     "coef":0.5,
   },
    "Shorts et bermudas":{
     "coef":0.9,
   },
    "Tops et t-shirts":{
     "coef":0.4,
   },
    "Vestes et manteaux":{
     "coef":0.25,
   }
 }
}